import Http from '../index.js'
import Model from '../Model.js'

class Notifications extends Model {
  constructor() {
    super('/notifications/')
  }

  listNotifications(query = '', config = {}) {
    return Http.get(`${this.model}list_notifications/${query}`, config)
  }

  notificationSettings() {
    return Http.get(`${this.model}notification_settings/`)
  }

  markAsRead(id) {
    return Http.post(`${this.model}mark_read/`, { notification_id: id })
  }

  markAllAsRead(config = {}) {
    return Http.post(`${this.model}mark_all_read/`, undefined, config)
  }

  getNotificationsSettings(query = '', config = {}) {
    return Http.get(`${this.model}notification_settings/${query}`, config)
  }

  updateUserNotificationsSettings(payload, config = {}) {
    return Http.post(`${this.model}update_notification_user/`, payload, config)
  }

  updateClientNotificationsSettings(payload, config = {}) {
    return Http.post(`${this.model}update_notifications_client/`, payload, config)
  }
}

export default new Notifications()
